var map = {
	"./de/title.png": "Rql8",
	"./en/title.png": "A8Kq",
	"./es/title.png": "ihHU",
	"./fr/title.png": "yGfm",
	"./ja/title.png": "WWjD",
	"./ko/title.png": "/o7W",
	"./pt/title.png": "Oa74",
	"./ru/title.png": "ZKcC",
	"./tc/title.png": "fdyn",
	"./th/title.png": "/ObA"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "CGJ4";